export const INPUT_TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
  EMAIL: 'email',
  NUMBER: 'number',
  TEL: 'tel',
  URL: 'url',
  DATE: 'date',
} as const;

export type InputType = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES];

export const INPUT_MODES = {
  TEXT: 'text',
  NUMERIC: 'numeric',
  /** Digits with at most one decimal point and two places after it — money and rates. */
  DECIMAL: 'decimal',
} as const;

export type InputMode = (typeof INPUT_MODES)[keyof typeof INPUT_MODES];
